import AlertSnackbar from "components/AlertSnackbar";
import React, {useState, createContext} from "react";

export const ErrorAndLoadingContext = createContext();


function ErrorHandlingAndLoading(props) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState("Operation successful")
  const [severity, setSeverity] = useState("success")

  return (
    <ErrorAndLoadingContext.Provider
      value={{
        snackbar: {
          setMsg,
          setSeverity,
          setOpen
        }
      }}
    >
      <AlertSnackbar
        open={open}
        msg={msg}
        severity={severity}
        setOpen={setOpen}
      />
      {props.children}
    </ErrorAndLoadingContext.Provider>
  );

}

export default ErrorHandlingAndLoading;